import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.222 19.931c2.642 0 5.05-.385 6.812-1.02.879-.317 1.617-.703 2.142-1.15.523-.447.874-.99.874-1.612 0-.622-.35-1.165-.874-1.612-.525-.447-1.263-.833-2.142-1.15-1.762-.635-4.17-1.02-6.812-1.02-2.643 0-5.05.385-6.812 1.02-.88.317-1.617.703-2.142 1.15-.524.447-.875.99-.875 1.612 0 .622.351 1.165.875 1.612.525.447 1.263.833 2.142 1.15 1.761.635 4.17 1.02 6.812 1.02Z",
  fill: "#454445",
  stroke: "#fff",
  "stroke-width": ".75",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.09 17.35a.375.375 0 0 0 .397-.002l1.47-.925a.375.375 0 0 0-.016-.643l-1.481-.84a.375.375 0 0 0-.37 0l-1.482.84a.375.375 0 0 0-.012.645l1.494.925ZM10.037 17.35a.375.375 0 0 0 .397-.002l1.47-.925a.375.375 0 0 0-.016-.643l-1.482-.84a.375.375 0 0 0-.37 0l-1.481.84a.375.375 0 0 0-.013.645l1.495.925ZM15.017 17.35a.375.375 0 0 0 .397-.002l1.47-.925a.375.375 0 0 0-.015-.643l-1.482-.84a.375.375 0 0 0-.37 0l-1.482.84a.375.375 0 0 0-.012.645l1.494.925Z",
  fill: "#403F40",
  stroke: "#D5D4D6",
  "stroke-width": ".75",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }